

































































import {Component, Vue} from "vue-property-decorator";
import PrimaryBtn from "@/components/infrastructures/atoms/designed/PrimaryBtn.vue";
import SubBtn from "@/components/infrastructures/atoms/designed/SubBtn.vue";
import {AuthGetterTypes} from "@/store/auth/types";
import {
  AuthPolicy,
  formatRetireDate,
  isEmailLike,
  RESEND_COOLDOWN_SECONDS
} from "@/components/domains/account/passwordless/authPolicy";
import PasswordlessService, {
  errorMessage,
  FALLBACK_ERROR,
  loadAuthPolicy
} from "@/components/domains/account/passwordless/passwordlessService";

/** ログイン中・メールアドレスのない人向けの設定画面（/mypage/mail-address）。 */
@Component({
  components: {PrimaryBtn, SubBtn}
})
export default class MailAddressSetupPage extends Vue {
  name = "MailAddressSetupPage";

  policy: AuthPolicy | null = null;
  deadline = "";

  phase: "form" | "sent" = "form";
  email = "";
  sentTo = "";
  error = "";
  info = "";
  sending = false;
  cooldown = 0;
  private timer: number | null = null;

  get currentEmail(): string {
    const user = this.$store.getters[AuthGetterTypes.getCurrentUser];
    return user && user.email ? String(user.email) : "";
  }

  mounted() {
    loadAuthPolicy({fresh: true}).then((policy) => {
      this.policy = policy;
      this.deadline = formatRetireDate(policy.noEmailPasswordLoginRetiresAt);
    });
  }

  beforeDestroy() {
    this.stopCooldown();
  }

  private startCooldown() {
    this.stopCooldown();
    this.cooldown = RESEND_COOLDOWN_SECONDS;
    this.timer = window.setInterval(() => {
      this.cooldown -= 1;
      if (this.cooldown <= 0) {
        this.stopCooldown();
      }
    }, 1000);
  }

  private stopCooldown() {
    if (this.timer !== null) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
    if (this.cooldown < 0) {
      this.cooldown = 0;
    }
  }

  private async send(address: string): Promise<boolean> {
    this.error = "";
    this.sending = true;
    try {
      await PasswordlessService.setupMailAddress(address);
      this.startCooldown();
      return true;
    } catch (e) {
      this.error = errorMessage(e, FALLBACK_ERROR);
      return false;
    } finally {
      this.sending = false;
    }
  }

  async submit() {
    if (this.sending) {
      return;
    }
    this.info = "";
    const address = this.email.trim();
    if (address === "") {
      this.error = "メールアドレスを入力してください。";
      return;
    }
    if (!isEmailLike(address)) {
      this.error = "メールアドレスの形式が正しくありません。";
      return;
    }
    if (await this.send(address)) {
      this.sentTo = address;
      this.phase = "sent";
    }
  }

  async resend() {
    this.info = "";
    if (this.cooldown > 0 || this.sending) {
      return;
    }
    if (await this.send(this.sentTo)) {
      this.info = "もう一度送りました。";
    }
  }

  changeAddress() {
    this.phase = "form";
    this.error = "";
    this.info = "";
  }
}
